"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskClick = void 0;
var analytics_layer_1 = require("@pmi/analytics-layer");
var consts_1 = require("../consts");
var taskClick = function (event) {
    var task = event.eventData.task;
    return {
        event: analytics_layer_1.TaskEventNames.TaskClick,
        eventInfo: analytics_layer_1.TaskEventNames.TaskClick,
        task: task.map(function (_a) {
            var taskName = _a.taskName, taskDisplayPosition = _a.taskDisplayPosition, productName = _a.productName;
            return ({
                taskName: taskName || consts_1.NOT_AVAILABLE,
                taskDisplayPosition: taskDisplayPosition !== null && taskDisplayPosition !== void 0 ? taskDisplayPosition : consts_1.NOT_AVAILABLE,
                productName: productName || consts_1.NOT_AVAILABLE,
            });
        }),
    };
};
exports.taskClick = taskClick;
